import * as yup from 'yup';

export const validation = yup.object().shape({
  modelGroupName: yup.string().required('Model group name is required'),
});
